module.exports = __webpack_public_path__ + "static/img/story3.4b3f60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/story3.png
// module id = lG7m
// module chunks = 0